import React from 'react';

import FieldRow from './FieldRow';
import { Input } from '../Inputs';
import { TextFieldProps } from './types';

export default function TextField({ mask, unmask, onChange, ...props }) {
    return (
        <FieldRow {...props}>
            {({ field: { name, value, ...field }, form: { errors, touched, setFieldValue } }) => (
                <Input
                    {...field}
                    name={name}
                    value={unmask ? unmask(value) : value}
                    hasError={errors[name] && touched[name]}
                    onChange={
                        onChange ||
                        ((e) => {
                            setFieldValue(name, mask ? mask(e.target.value) : e.target.value);
                        })
                    }
                />
            )}
        </FieldRow>
    );
}

TextField.propTypes = TextFieldProps;
